import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';

import * as Enum from '../../../dtos/enums';
import { TestTakerService } from '../../../services/test-taker.service';
import { TestNavigationService } from '../../../services/test-navigation.service';
import { TestContentService } from '../../../services/test-content.service';
import { ResponseService } from '../../../services/response.service';

@Component({
    selector: 'page-nav',
    template: require('./page-nav.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNavComponent implements OnInit, OnDestroy {
    @Input() testlet$: Observable<PgRendererDto.TestletDefinition>;
    @Input() itemIndex$: Observable<number>;
    @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

    isVisible: boolean;
    testlet: PgRendererDto.TestletDefinition;
    itemIndex: number;
    responsesSubscription: Subscription;
    testletSubscription: Subscription;
    itemIndexSubscription: Subscription;
    assessmentItemList: PgRendererDto.AssessmentItem[];

    constructor(
        private responseService: ResponseService,
        private changeDetectorRef: ChangeDetectorRef,
        private testContentService: TestContentService,
        private testNavigationService: TestNavigationService,
        private testTakerService: TestTakerService
    ) {
    }

    ngOnInit() {
        this.responsesSubscription = this.responseService.responses$.subscribe(x => {
            this.changeDetectorRef.markForCheck();
        });

        this.testletSubscription = this.testlet$.subscribe(testlet => {
            this.testlet = testlet;
            this.initAssessmentItemList();
        });

        this.itemIndexSubscription = this.itemIndex$.subscribe(itemIndex => {
            this.itemIndex = itemIndex;
            this.initAssessmentItemList();
        });
    }

    ngOnDestroy() {
        if (this.responsesSubscription) {
            this.responsesSubscription.unsubscribe();
        }
        if (this.testletSubscription) {
            this.testletSubscription.unsubscribe();
        }
        if (this.itemIndexSubscription) {
            this.itemIndexSubscription.unsubscribe();
        }
    }

    onPageChange(index: number) {
        this.testNavigationService.changeAssessmentItem(index);
    }

    goNext() {
        const activeItem = this.testlet.AssessmentItems[this.itemIndex];
        if (activeItem.DisplayPageNumber < this.assessmentItemList.length) {
            this.testTakerService.cacheTestTakerActivity(Enum.TestTakerActivityTypeEnum.PageNavigationArrowClick, null, "next", this.testContentService.activeTestletId);
            this.testNavigationService.changeAssessmentItem(this.itemIndex + 1);
        }
    }

    goPrev() {
        const activeItem = this.testlet.AssessmentItems[this.itemIndex];
        const minItemIndex = this.testlet.AssessmentItems.find(x => x.GroupNumber == activeItem.GroupNumber && x.DisplayPageNumber == 1).ItemIndex;
        if (this.itemIndex > minItemIndex) {
            this.testTakerService.cacheTestTakerActivity(Enum.TestTakerActivityTypeEnum.PageNavigationArrowClick, null, "prev", this.testContentService.activeTestletId);
            this.testNavigationService.changeAssessmentItem(this.itemIndex - 1);
        }
    }

    allInteractionsAnswered(item: PgRendererDto.AssessmentItem): boolean {
        return this.responseService.getUnansweredInteractionCountInAssessmentItem(item) == 0;
    }

    private initAssessmentItemList() {
        let activeItem = null;
        if (this.testlet) {
            activeItem = this.testlet.AssessmentItems[this.itemIndex];
        }

        if (activeItem) {
            this.assessmentItemList = this.testlet.AssessmentItems.filter(x => x.GroupNumber == activeItem.GroupNumber);
        } else {
            this.assessmentItemList = [];
        }

        this.changeDetectorRef.markForCheck();
    }

}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/page-nav/page-nav.component.ts